import { css } from '@emotion/react';
import React from 'react';

import { media, screens } from '../shared/styles';
import Box, { BoxProps } from './Box';

const baseStyles = css`
  width: 100%;
  margin: 0 auto;
  padding-left: 1rem;
  padding-right: 1rem;

  ${media.sm} {
    max-width: ${screens.sm};
  }

  ${media.md} {
    max-width: ${screens.md};
  }

  ${media.lg} {
    max-width: ${screens.lg};
  }

  ${media.xl} {
    max-width: ${screens.xl};
  }
`;

const fullWidthStyles = css`
  ${media.sm} {
    max-width: 100%;
  }
`;

type Props = BoxProps & {
  isFullWidth?: boolean;
};

const Container = ({
  children,
  className,
  isFullWidth = false,
  ...props
}: Props) => {
  return (
    <Box
      css={[baseStyles, isFullWidth && fullWidthStyles]}
      className={className}
      {...props}
    >
      {children}
    </Box>
  );
};

export default Container;
